const LOCALE_PREFIX = /^\/(ar|en)(?=\/|$)/;
const bareHost = (host) => host.replace(/^www\./, "");

/**
 * Turns an admin-entered link into something next/link can localise.
 * Relative paths and absolute URLs on this site become a path without its locale prefix, so the
 * shopper stays in their own language (an `/en/…` link entered once must not switch an Arabic
 * shopper to English). Links to other hosts are returned unchanged.
 * Client-only: it compares against the host the page is served from.
 */
export function toSiteHref(link) {
  const value = typeof link === "string" ? link.trim() : "";
  if (!value) return null;
  let url;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return null;
  }
  if (!/^https?:$/.test(url.protocol)) return null;
  if (bareHost(url.hostname) !== bareHost(window.location.hostname)) return url.href;

  const path = url.pathname.replace(LOCALE_PREFIX, "") || "/";
  return `${path}${url.search}${url.hash}`;
}
